import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ITableDelegate, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';

@UntilDestroy()
@Component({
    selector: 'app-ar-templates-list-dialog-component',
    templateUrl: './ar-templates-list-dialog.component.html',
    styleUrls: ['./ar-templates-list-dialog.component.scss'],
})
export class ArTemplatesListDialogComponent implements ITableDelegate {
    public options: ITableOptions | undefined;

    arTemplatesOptions: INameId[] = [];
    selectedArTemplateId: string | undefined;

    constructor(
        private readonly dialogRef: MatDialogRef<ArTemplatesListDialogComponent, string | undefined>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public arTemplates: INameId[],
    ) {
        this.arTemplatesOptions = cloneDeep<INameId[]>(arTemplates);
        this.addSvgIcon('interface-delete 1');

        this.options = {
            columns: [
                {
                    name: 'select',
                    flex: 10,
                },
                { name: 'Template Name', type: 'text', property: 'name', flex: 50 },
            ],
            singleSelectionProperty: 'id',
        };
    }

    closeDialog(): void {
        this.dialogRef.close(undefined);
    }

    selectArTemplate(): void {
        this.dialogRef.close(this.selectedArTemplateId);
    }

    onSingleRowSelection(arTemplateId: string, checked: boolean): void {
        if (checked == true) {
            this.selectedArTemplateId = arTemplateId;
        } else {
            this.selectedArTemplateId = undefined;
        }
    }

    onRowButtonClicked(id: string, action?: string): void {}

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>) {}

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
